import { Box, useBreakpointValue } from "@chakra-ui/react";
import React from "react";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { DesktopHeader } from "./DesktopHeader";
import { MobileHeader } from "./MobileHeader";

const Header = () => {
  const { logoMainFileId } = useContextConsumer();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  return (
    <Box zIndex={2} w="100%" position="fixed">
      {isMobile ? (
        <MobileHeader logoFileId={logoMainFileId} />
      ) : (
        <DesktopHeader logoFileId={logoMainFileId} />
      )}
    </Box>
  );
};

export { Header };
